import { Form, message, Modal } from "antd";
import React from "react";
import { QuoteGet } from "../../../../models/quote";
import { HotSheetPost } from "../../../../models/hotsheet";
import { QuoteSelector } from "../../workorder/popups/QuoteSelector";

const FormItem = Form.Item;

export class ImportQuoteForm extends React.Component {
  state = {};

  handleImportQuote = () => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        QuoteGet(values.quote)
          .then(response => {
            values['generator'] = response.data.generator.id;
            values['bill_to'] = response.data.bill_to.id;
            values['payment_term'] = response.data.payment_term.id;
            values['job_description'] = response.data.job_description;
            values['service'] = response.data.service[0].id;
            HotSheetPost(values)
              .then(response => {
                message.success('Hot Sheet imported successfully');
                this.props.setModelVisible();
                this.props.fetch()
              })
          });
      }
    })
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields } = this.state;
    return (
      <Modal title="Select Quote" centered visible={this.props.visible} onOk={this.handleImportQuote} onCancel={() => this.props.setModelVisible()} width="30%" className="cat-modal select-quote-mdl" okText="Import Quote">
        <Form onSubmit={this.handleImportQuote}>
          <FormItem>
            {getFieldDecorator('quote', {
              rules: [{ required: true, message: 'Please select quote ' }],
            })(
              <QuoteSelector {...fields} type='hotsheet' />
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export const ImportQuote = Form.create()(ImportQuoteForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/hotsheet/popups/ImportQuote.jsx